"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = exports.ExampleWithInfoIcon = exports.SimpleExample = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const SimpleExample = () => (react_1.default.createElement(UiKitLite_1.UiKitLite.Table, { headers: [
        {
            content: 'Diner',
            width: '200px',
        },
        {
            content: 'Address',
            width: '400px',
        },
        {
            content: 'Top Food',
            width: 'auto',
        },
    ], data: [
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'diner' }, "Denny's"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'address' }, "816 Mission St, San Francisco, CA 94103"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'food' }, "Original Grand Slam"),
        ],
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'diner' }, "Pinecrest"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'address' }, "401 Geary St, San Francisco, CA 94102"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'food' }, "Pinecrest Special"),
        ],
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'diner' }, "Mel's Drive-In"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'address' }, "801 Mission St, San Francisco, CA 94103"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'food' }, "Breakfast Sandwich"),
        ],
    ] }));
exports.SimpleExample = SimpleExample;
const ExampleWithInfoIcon = () => (react_1.default.createElement(UiKitLite_1.UiKitLite.Table, { headers: [
        {
            content: 'Car',
            width: '300px',
            infoTooltip: 'The company who manufactures this vehicle.',
        },
        {
            content: 'Model',
            width: '300px',
        },
        {
            content: 'Top Speed',
            width: 'auto',
            infoTooltip: 'The maximum speed of this car in miles per hour.',
        },
    ], data: [
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'car' }, "VW"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'model' }, "Golf"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'speed' }, "110"),
        ],
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'car' }, "Ford"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'model' }, "F150"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'speed' }, "120"),
        ],
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'car' }, "Tesla"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'model' }, "Model S"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'speed' }, "140"),
        ],
        [
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'car' }, "Mazda"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'model' }, "3"),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { key: 'speed' }, "130"),
        ],
    ] }));
exports.ExampleWithInfoIcon = ExampleWithInfoIcon;
const Table = () => (react_1.default.createElement(react_2.VStack, { align: 'stetch', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
    react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Heading3, { text: 'Simple example' }),
    react_1.default.createElement(exports.SimpleExample, null),
    react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Heading3, { text: 'Example with info icon' }),
    react_1.default.createElement(exports.ExampleWithInfoIcon, null)));
exports.Table = Table;
